import { render, staticRenderFns } from "./AdminTasks.vue?vue&type=template&id=5412c88e&scoped=true&"
import script from "./AdminTasks.vue?vue&type=script&lang=js&"
export * from "./AdminTasks.vue?vue&type=script&lang=js&"
import style0 from "./AdminTasks.vue?vue&type=style&index=0&id=5412c88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5412c88e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5412c88e')) {
      api.createRecord('5412c88e', component.options)
    } else {
      api.reload('5412c88e', component.options)
    }
    module.hot.accept("./AdminTasks.vue?vue&type=template&id=5412c88e&scoped=true&", function () {
      api.rerender('5412c88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminTasks.vue"
export default component.exports